import axios from "axios";
import { APP_DISPLAY_ADS_API_ENDPOINT } from "../../../../constants/api_urls";
import {getUserToken} from "../../../../utils/functions/userToken";

export const updateCampaignStatus = async (payload) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.put(
            `${APP_DISPLAY_ADS_API_ENDPOINT}/api/display-ads/edit-campaign/update-status/`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error.response?.data || "Failed to update campaign status.";
    }
};